import { Button, Link, Modal } from '@inato/ui';

import { useNotificationService } from '../../../notificationService/NotificationServiceContext';
import { CONTACT_US_EMAIL } from '../../constants/emails';

export const ContactUsModal = ({ onClose }: { onClose: () => void }) => {
  const notificationService = useNotificationService();

  const handleCopy = async () => {
    await navigator.clipboard.writeText(CONTACT_US_EMAIL);
    notificationService.notify({
      message: 'Email copied',
      type: 'success',
    });
  };

  return (
    <Modal
      title="Contact us"
      onRequestClose={onClose}
      primaryAction={{
        label: 'Close',
        onClick: onClose,
      }}
    >
      Use the following email address to contact us about any inquiries.
      <br />
      We read and reply to all emails.
      <div className="tablet:mx-auto tablet:mb-zero tablet:mt-l tablet:block tablet:text-center hidden">
        <input
          className="mb-m border-border-dark px-m py-s m-auto box-border inline-block rounded border border-solid outline-hidden select-all"
          name="contact-us-email"
          readOnly
          type="text"
          onClick={event => event.currentTarget.select()}
          value={CONTACT_US_EMAIL}
          size={CONTACT_US_EMAIL.length}
        />
        <Button
          className="m-auto block"
          variant="tertiary"
          onClick={handleCopy}
        >
          Copy email address
        </Button>
      </div>
      <div className="mt-l tablet:hidden block text-center">
        <Link href={`mailto:${CONTACT_US_EMAIL}`}>{CONTACT_US_EMAIL}</Link>
      </div>
    </Modal>
  );
};
